import Collection from './collection.js';
import AnnotationAuditLog from '../models/annotation-audit-log.js';

export default class AnnotationAuditLogCollection extends Collection {
  _initProperties() {
    this.image = null;
    this.annotation = null;
  }

  get uri() {
    if (this.image) {
      return `imageinstance/${this.image}/annotation-audit-log.json`;
    }
    if (this.annotation) {
      return `annotation/${this.annotation}/audit-log.json`;
    }
    throw new Error('An image or annotation identifier is required to fetch annotation audit logs.');
  }

  static async fetchByImage(image, {offset = 0, max = 50} = {}) {
    let collection = new this({image, nbPerPage: max});
    collection.offset = offset;
    await collection._fetch();
    return collection;
  }

  static async fetchByAnnotation(annotation, {offset = 0, max = 50} = {}) {
    let collection = new this({annotation, nbPerPage: max});
    collection.offset = offset;
    await collection._fetch();
    return collection;
  }

  static get model() {
    return AnnotationAuditLog;
  }

  static get allowedFilters() {
    return [null];
  }
}
